// extracted by mini-css-extract-plugin
var _1 = "PostMention-module__publicIcon--FA2fC";
export { _1 as "publicIcon" }
